import CompanyVehicleBrandLinkTypes from 'store/actionTypes/companyVehicleBrandLink'
import UserTypes from 'store/actionTypes/user'
import VehicleBrandTypes from 'store/actionTypes/vehicleBrand'

const initialData = {
  list: [],
  current: {},
  messages: {
    list: [],
    pagination: {}
  },
  pagination: {},
  systems: [],
  companyVehicleBrandLink: {
    list: [],
    pagination: {}
  }
}

const vehicleBrand = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case VehicleBrandTypes.GET_VEHICLE_BRANDS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case VehicleBrandTypes.GET_VEHICLE_BRAND_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case VehicleBrandTypes.UPDATE_FILTER_VEHICLE_BRAND_SUCCESS:
      return { ...state, filter: payload }
    case VehicleBrandTypes.CLEAR_FILTER_VEHICLE_BRAND_SUCCESS:
      return { ...state, filter: initialData.filter }
    case VehicleBrandTypes.GET_VEHICLE_BRAND_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case VehicleBrandTypes.GET_SYSTEM_VEHICLE_BRANDS_SUCCESS:
      return { ...state, systems: payload?.items }

    case CompanyVehicleBrandLinkTypes.GET_COMPANY_VEHICLE_BRAND_LINKS_SUCCESS:
      return {
        ...state,
        companyVehicleBrandLink: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default vehicleBrand
